import '../assets/styles/global.scss';
import React, { useEffect, useRef, useState } from 'react';
import footerLogo from '../assets/images/footer-logo.svg';
function Footer({hasFirstSection, openChat, bgColor }) {

    const [goftinoReady, setGoftinoReady] = useState(false);

    useEffect(() => {
        const handleGoftinoReady = () => {
          setGoftinoReady(true);
        };
      
        // Check immediately if already loaded
        if (window.Goftino) {
          setGoftinoReady(true);
        } else {
          // Wait for it to load
          window.addEventListener('goftino_ready', handleGoftinoReady);
        }
      
        return () => {
          window.removeEventListener('goftino_ready', handleGoftinoReady);
        };
      }, []);


      const handleClickChat = () => {
        if (goftinoReady && window.Goftino) {
          window.Goftino.open();
        } else if (openChat) {
          openChat(); // Fallback to parent function if available
        }
      };

  return (
    <footer>

        {
            hasFirstSection ? (
                <div className="first-section">
            <div className='left'>
                <div className='first-left'>
                    <img src={require('../assets/images/footer-1.png')} alt='some'/>
                    <img src={require('../assets/images/footer-2.png')} alt='some'/>
                </div>
                <div className='second-left'>
                    <img src={require('../assets/images/footer-3.png')}/>
                </div>
            </div>
            <div className='right'>
                <h3>پذیرش شبانه‌روزی بار در ترمینال مرکزی وطن</h3>
                <p>حمل‌ونقل وطن آماده دریافت بار شما در تمام روزهای هفته و در هر ساعت از شبانه‌روز می‌باشد.</p>
                <a onClick={handleClickChat}>ارسال بار</a>
            </div>
            
            
        </div>
            ) : null
        }

        <div className="second-section" style={{backgroundColor: bgColor ? bgColor : ''}}>
            <div className='logo-container'>
            <img src={footerLogo} alt='Footer Logo'/>
                <h5>وطن، برند برتر!</h5>
                <p>تمام حقوق مادی و معنوی این وبسایت متعلق به حمل‌ونقل وطن است.</p>
            </div>

            <div className='links-list'>
                
                <div className='link-item'>
                    <h5>وطن</h5>
                    <a href='/about' target='_blank'>درباره ما</a>
                    <a href='/blog' target='_blank'>اخبار وطن</a>
                </div>

                <div className='link-item'>
                    <h5>پشتیبانی</h5>
                    <a href='/contact' target='_blank'>تماس با ما</a>
                    <a href='/contact' target='_blank'>ساعات کاری</a>
                    <a onClick={handleClickChat}>چت آنلاین</a>
                </div>
                
                <div className='link-item'>
                    <h5>خدمات</h5>
                    <a onClick={handleClickChat}>ارسال بار</a>
                    <a href='/express' target='_blank'>وطن اکسپرس</a>
                    <a href='/vipClient' target='_blank'>مشتریان ویژه تجاری</a>
                </div>

                <div className='link-item'>
                    <h5>راهنما</h5>
                    <a href='/contact#department-map' target='_blank' >نمایندگی‌های تخلیه‌بار</a>
                    <a href='/#destiny' target='_blank'>مراحل ارسال بار</a>
                    <a  href='/contact#faq-list' target='_blank'>پرسش‌های پرتکرار</a>
                </div>

               

            </div>
        </div>

    </footer>
  );
}

export default Footer;
